import { motion } from "framer-motion";
import { Camera } from "lucide-react";

const SHOTS = [
  {
    src: "/brand/sy-sy-event.jpg",
    cap: "Serving smiles at the park",
    tilt: "rotate-[-2deg]",
  },
  {
    src: "/brand/team-laughing.jpg",
    cap: "Laughter always included",
    pos: "object-[center_25%]",
    tilt: "rotate-[1.5deg]",
  },
  {
    src: "/brand/kid-with-menu.jpg",
    cap: "Even the kids approve",
    tilt: "rotate-[2deg]",
  },
  {
    src: "/brand/team-tees.jpg",
    cap: "Official uniform vibes",
    pos: "object-[center_30%]",
    tilt: "rotate-[-1.5deg]",
  },
  {
    src: "/brand/night-market.jpg",
    cap: "Market nights hit different",
    pos: "object-[center_25%]",
    imgH: "h-72 sm:h-96",
    tilt: "rotate-[1.5deg]",
  },
  {
    src: "/brand/box-haul.jpg",
    cap: "One box feeds the crew",
    pos: "object-[center_30%]",
    imgH: "h-72 sm:h-96",
    tilt: "rotate-[-2deg]",
  },
  {
    src: "/brand/lemonade-sip.jpg",
    cap: "Ice cold and gone fast",
    pos: "object-[center_30%]",
    imgH: "h-72 sm:h-96",
    tilt: "rotate-[2deg]",
  },
];

export default function Gallery() {
  return (
    <section data-testid="gallery-section" className="dots-bg bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.24em] text-tang">From past events</p>
            <h2 className="font-display mt-3 text-4xl font-bold sm:text-5xl">
              Catch us around <span className="font-logo text-tomato">Bakersfield</span>
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 rounded-full border-[3px] border-ink bg-sunburst px-4 py-2 text-xs font-black uppercase tracking-wide shadow-popSm">
            <Camera className="h-4 w-4" strokeWidth={2.75} /> Real events, real smiles
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-5 sm:gap-7">
          {SHOTS.map((s, i) => (
            <motion.figure
              key={s.src}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`gallery-tile-${i}`}
              className={`${s.tilt} w-[46%] rounded-2xl border-[3px] border-ink bg-white p-2.5 shadow-pop transition-transform duration-300 hover:rotate-0 hover:-translate-y-1 sm:w-[300px] lg:w-[calc(25%-21px)]`}
            >
              <img
                src={s.src}
                alt={s.cap}
                loading="lazy"
                className={`w-full rounded-xl object-cover ${s.imgH || "h-40 sm:h-52"} ${s.pos || ""}`}
              />
              <figcaption className="font-display block px-1 pb-1 pt-2 text-center text-xs font-semibold uppercase tracking-wider text-ink/70 sm:text-sm">
                {s.cap}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
